var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "facebook-square"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.8125 1.875H5.1875C4.44158 1.875 3.72621 2.17132 3.19876 2.69876C2.67132 3.22621 2.375 3.94158 2.375 4.6875L2.375 25.3125C2.375 26.0584 2.67132 26.7738 3.19876 27.3012C3.72621 27.8287 4.44158 28.125 5.1875 28.125H13.2295V19.2006H9.53809V15H13.2295V11.7984C13.2295 8.15684 15.3975 6.14531 18.718 6.14531C20.3082 6.14531 21.9711 6.42891 21.9711 6.42891V10.0031H20.1389C18.3336 10.0031 17.7705 11.1234 17.7705 12.2725V15H21.8006L21.1561 19.2006H17.7705V28.125H25.8125C26.5584 28.125 27.2738 27.8287 27.8012 27.3012C28.3287 26.7738 28.625 26.0584 28.625 25.3125V4.6875C28.625 3.94158 28.3287 3.22621 27.8012 2.69876C27.2738 2.17132 26.5584 1.875 25.8125 1.875Z",
    fill: "#E7EF7D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookSquare);
export default __webpack_public_path__ + "static/media/facebook-square.ddfee27ee08d29d45817b088ee2bb860.svg";
export { ForwardRef as ReactComponent };